module.exports = __webpack_public_path__ + "static/media/eye-watermark-dark.72e251ee.svg";